import { PersonBus } from "./PersonBus";
import { CustomerLogoBus } from "./CustomerLogoBus";
import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class SystemEventSubscriptionsBus extends BaseBus
{
    constructor(busObj: SystemEventSubscriptionsBus = null) {
        super(busObj);
    }
    CID(): any {
        return this.eventSubscriptionsId;
    }
    
    eventSubscriptionsId: any; 
    systemEventId: any;
    customerId: any;
    locationId: any;
    customerName: string;
    locationName: string;
    statusId: any;
    subscribedUserId: any;
    subscribedEmail: number;
    companyId: any;
    insertDt: Date;
    UpdateDt: Date;
    eventName: string;
    eventDescription: string;
    IsActive: boolean;
    hasFilters: boolean;
    instanceDays: number;
    instances: number;
    regionId: any;
    divisionId: any;
    onCallRegionId: any;
    serviceManagerId: any;
    accountManagerId: any;
    contractAdminId: any;
    billerId: any;
    dispatchStatusId: any;
    contractStatusId: any;
    jobStatusId: any;
    companyBranchId: any;

    division: any;
    onCallRegion: any;
    serviceManager : any;
    accountManager: any;
    contractAdmin: any;
    biller: any;
    dispatchStatus: any;
    contractStatus: any;
    jobStatus: any;
    companyBranch: any;

}
